export const LOGIN_ENDPOINT = "https://pay.telin.tw/spalogin";
export const GRAPHQL_ENDPOINT = "https://pay.telin.tw/graphql";
export const LEVEL = ["NORMAL", "ADMIN", "ANY"];
export const BARCODE_URL = "https://pay.telin.tw/bc/";
